import React from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';

type AddFormElements = {
  name: string;
  onClick: () => void;
};

export function AddFormElements({ name, onClick }: AddFormElements) {
  return (
    <button type="button" className="add-form-elements" onClick={onClick}>
      <span className="add-form-elements__name">{name}</span>
      <span className="add-form-elements__icon">
        <SVG svgSpriteId={Icons.ADD_PLUS} />
      </span>
    </button>
  );
}
